const getBackendHosts = () => {
  const baseHostName = window.location.hostname;

  if (baseHostName.includes("localhost") || baseHostName.includes("staging")) {
    return {
      WEALTHVAULT:"https://wealthvault-frontend-staging.tradeboss.co/",
      EXPERTRECMD: "https://expert-recommendation-frontend-staging.tradeboss.co/",
      REG: "https://kyc-frontend-staging.tradeboss.co",
      ADMIN:"https://admin-backend-staging.tradeboss.co",
      BACKOFFICE:"https://backoffice.tradeboss.co",
      TRADEPLF:"https://login.tradeboss.co/#!/app",
    };
  } else {
    return {
      WEALTHVAULT: "https://wealthvault-frontend.tradeboss.co/",
      EXPERTRECMD: "https://expert-recommendation-frontend.tradeboss.co/",
      REG: "https://kyc.tradeboss.co",
      ADMIN:"https://admin-backend.tradeboss.co",
      BACKOFFICE: "https://backoffice.tradeboss.co",
      TRADEPLF: "https://login.tradeboss.co/#!/app",
    };
  }
};
const backendHosts = getBackendHosts();

const  apiUrl={

  //blogs
  getAllBlogs: "/api/blogs",
  getABlog: "/api/blogs/",
  getAllTags: "/api/blogs/tags",

  //Research
  getResearch:"/api/research/all",
  getCategories:"/api/research/categories",

  //ticket
  ticket:"/api/ticket-tracker/tickets"
}

export { backendHosts, apiUrl };
